import React, { useEffect, useState } from "react";

import { loginCheckApi } from "./api";

export function withCookieCheck(WrappedComponent: React.ComponentType<any>) {
    return function WithCookieCheckComponent(props: any) {

        useEffect(() => {
            const fetchComponent = async () => {
                try {
                    const origin = window.location.pathname;

                    // Make request to token check endpoint
                    const response = await loginCheckApi();

                    // If request fails, redirect to login
                    if (!response.ok) {
                        console.log("LOGIN CHECK WAS NOT OK");
                        if (origin === "/auth") {
                            window.location.href  = "/auth/basic_login";
                        }
                        return;
                    }

                } catch (error) {
                    console.error("Error during login check:", error);
                    window.location.href = "/auth/basic_login";
                    return;
                }
            };

            fetchComponent();
        }, []);

        // Render the wrapped component if everything is fine
        return <WrappedComponent {...props} />;
    };
}
